import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WorkerRoutingModule } from './worker-routing.module';
import { TimesheetsComponent } from './timesheets/timesheets.component';
import { WorkerSafetyboxComponent } from './worker-safetybox/worker-safetybox.component';
import { WorkerDashboardComponent } from './worker-dashboard/worker-dashboard.component';
import { WorkerService } from './service/worker.service';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { ScrollEventModule } from 'ngx-scroll-event';
import { FileDropModule } from 'ngx-file-drop';
import { CalendarModule } from 'primeng/calendar';
import { EditorModule } from 'primeng/editor';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { WorkerRegistrationComponent } from './worker-registration/worker-registration.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    ScrollEventModule,
    FileDropModule,
    CalendarModule,
    EditorModule,
    AutoCompleteModule,
    WorkerRoutingModule,
    SharedModule,
    TranslateModule
  ],
  declarations: [ TimesheetsComponent, WorkerSafetyboxComponent, WorkerDashboardComponent, WorkerRegistrationComponent],
  providers: [WorkerService]
})
export class WorkerModule { }



// WEBPACK FOOTER //
// ./src/app/worker/worker.module.ts